module.exports = __webpack_public_path__ + "static/img/cup_orange.88d38fd8.png";